import React from "react";
import "./CoachComments.css";

export default function CoachComments(props) {
  return (
    <div className="coachCommentsContainer">
      <h3>نظرات مربی</h3>
      <div className="coachComments centeredFlex">
        {props.comment.length > 0 ? (
          <span className="coachCommentText">{props.comment}</span>
        ) : (
          <span className="commentNotFound">اطلاعاتی یافت نشد</span>
        )}
      </div>
      <p className="commentDate">{props.shamsiDate}</p>
    </div>
  );
}
